import { render } from "./AlternativeDashboardPage.vue?vue&type=template&id=ce58c78e&scoped=true&ts=true"
import script from "./AlternativeDashboardPage.vue?vue&type=script&lang=ts"
export * from "./AlternativeDashboardPage.vue?vue&type=script&lang=ts"

import "./AlternativeDashboardPage.vue?vue&type=style&index=0&id=ce58c78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce58c78e"]])

export default __exports__